<div class="pc-bg">
  <div id="progress-tracker" (window:resize)="onResize($event)">
    <div class="progress-tracker-container">
      <div *ngIf="!isAuthPage">
        <h1 id="heading" *ngIf="showEligibilityHeading">{{eligibility_heading}}</h1>
        <h1 id="heading" *ngIf="showInfoHeading">{{information_heading}}</h1>
        <!-- <h1 id="heading" *ngIf="showActivationHeading">{{cfetLabels.cfet_customer_eligibility.utf_activation_heading}} -->
        <!-- </h1> -->
      </div>
      <div *ngIf="isAuthPage">
        <h1 id="heading">{{cfetLabels.utf_auth_page.tracker_heading}}</h1>
        <p id="auth-content">{{cfetLabels.utf_auth_page.tracker_content}}</p>
      </div>
      <div id="all-track" class="row no-gutters" *ngIf="!isAuthPage">
        <div class="col-12" *ngIf="true" id="track1">
          <div class="row no-gutters" id="track1">
            <div class="col-lg-12">
              <div class="row no-gutters">
                <div class="col-lg-1 col-xs-12" id="circle">
                  <button [ngClass]="progressTrackerStatus === 'roleDetails'|| progressTrackerStatus === 'profileInfo' || progressTrackerStatus ==='createPwd' || progressTrackerStatus ==='confirmOtppage' || progressTrackerStatus === 'orgDetails' || progressTrackerStatus === 'EligibilityCompletion' ? 'btn1-selected' : 'btn1'" id="btn1-desc" aria-label="step1">
                    <p *ngIf="stepOneIcon" id="btn-no">1</p>
                    <p *ngIf="stepOneTickIcon" id="btn-tick">&#10003;</p>
                  </button>
                </div>
                <div class="col-lg-11 col-xs-12 ul" id="text">
                  <p [ngClass]="[progressTrackerStatus === 'roleDetails'|| progressTrackerStatus === 'profileInfo' || progressTrackerStatus ==='createPwd' || progressTrackerStatus ==='confirmOtppage' || progressTrackerStatus === 'orgDetails' || progressTrackerStatus === 'EligibilityCompletion' ? 'static-text1-selected' : 'static-text',
                  underLineStep1? 'ul-1': '']" id="static-text-desc">
                    {{eligibility_subheading}}
                    <span class="agency-text">
                      {{eligibility_subheading1}}
                    </span>
                  </p>
                </div>
              </div>
            </div>
            <span [ngClass]="stepOneEligibilitypage? 'solid-line1': 'vertical-line1'"></span>

            <!-- <div id="show-sub-details" class="col-lg-12 col-8">
              <div class="row no-gutters">
                <div class="col-lg-12 col-6 role-mobile-max">
                  <div class="row no-gutters sub-detail1">
                    <div class="col-xs-12 col-lg-1">
                      <p id="sub-detail-btn" class="sub-bt" [ngClass]="stepOneEligibilitypage? 'sub-bt-disc': 'sub-bt'">
                      </p>
                    </div>
                    <div class="col-xs-12 col-lg-10 sub-detail-heading"
                      [ngClass]="(progressTrackerStatus == 'roleDetails') ? 'ff-b' : 'ff-nb'">
                      {{cfetLabels.cfet_customer_eligibility.utf_role_details}}</div>
                  </div>
                </div>
                <span [ngClass]="stepOneRoleDone? 'solid-line sl2': 'vertical-line2'" class="solid-line2 ml-3"
                  id="vertical-line-2"></span>
                <div class="col-lg-12 col-6 role-mobile-max">
                  <div class="row no-gutters last-block sub-detail2">
                    <div class="col-xs-12 col-lg-1">
                      <p id="sub-detail-btn" class="sub-bt last-btn"
                        [ngClass]="(progressTrackerStatus == 'orgDetails' || progressTrackerStatus == 'EligibilityCompletion' || stepOneTickIcon) ? 'sub-bt-disc': 'sub-bt'">
                      </p>
                    </div>
                    <div class="col-xs-12 col-lg-10 sub-detail-heading last-block"
                      [ngClass]="(progressTrackerStatus == 'orgDetails') ? 'ff-b' : 'ff-nb'">
                      {{cfetLabels.cfet_customer_eligibility.utf_org_details}}</div>
                  </div>
                </div>
              </div>
            </div> -->
            <!-- <span [ngClass]="stepOneDone? 'solid-line': 'vertical-line3'" *ngIf="stepOneDone"></span> -->
          </div>
        </div>
        <div class="col-12" id="profile-info-step">
          <div class="row no-gutters" id="track2">
            <div class="col-lg-12">
              <div class="row no-gutters">
                <div class="col-lg-1 col-xs-12" id="circle">
                  <button id="btn2-desc" [ngClass]="progressTrackerStatus === 'profileInfo'|| progressTrackerStatus == 'verified' || progressTrackerStatus == 'createPwd' || progressTrackerStatus == 'confirmOtppage' ? 'btn2-selected' : 'btn1' " aria-label="step2"
                    [disabled]="disableStep">
                    <p *ngIf="stepTwoIcon" id="btn-no">2</p>
                    <p *ngIf="stepTwoTickIcon" id="btn-no">2</p>
                  </button>
                </div>
                <div class="col-lg-11 col-xs-12" id="text">
                  <p [ngClass]="[progressTrackerStatus === 'profileInfo'|| progressTrackerStatus == 'verified' || progressTrackerStatus == 'createPwd' || progressTrackerStatus == 'confirmOtppage' ? 'static-text2-selected' : 'static-text',
                  underLineStep2? 'ul-2': '', isMobile? 'bold-mobile': 'not-bold']" id="static-text-desc">
                    {{cfetLabels.cfet_customer_eligibility.information}}</p>
                </div>
              </div>
            </div>
            <span [ngClass]="stepTwoInformationpage? 'solid-line': 'vertical-line1'"></span>
            <!-- <div id="show-sub-details" class="col-lg-12 col-8">
              <div class="row no-gutters">
                <div class="col-lg-12 col-6 role-mobile-max">
                  <div class="row no-gutters sub-detail1">
                    <div class="col-xs-12 col-lg-1">
                      <p id="sub-detail-btn" class="sub-bt" [ngClass]="stepTwoInformationpage? 'sub-bt-disc': 'sub-bt'">
                      </p>
                    </div>
                    <div class="col-xs-12 col-lg-10 sub-detail-heading"
                      [ngClass]="(progressTrackerStatus == 'profileInfo') ? 'ff-b' : 'ff-nb'">
                      {{cfetLabels.cfet_customer_eligibility.utf_profile_info}}</div>
                  </div>
                </div>
                <span
                  [ngClass]="(stepTwoProfileDone || progressTrackerStatus == 'verified') ? 'solid-line sl2': 'vertical-line2'"
                  class="solid-line2"></span>
                <div class="col-lg-12 col-6 role-mobile-max">
                  <div class="row no-gutters last-block sub-detail2" id="verify-row">
                    <div class="col-xs-12 col-lg-1">
                      <p id="sub-detail-btn" class="sub-bt last-btn"
                        [ngClass]="(progressTrackerStatus == 'verified' || stepTwoProfileDone) ? 'sub-bt-disc': 'sub-bt'">
                      </p>
                    </div>
                    <div class="col-xs-12 col-lg-10 sub-detail-heading last-block"
                      [ngClass]="(progressTrackerStatus == 'verified') ? 'ff-b' : 'ff-nb'">
                      {{cfetLabels.cfet_customer_eligibility.utf_doc_upload}}</div>
                  </div>
                </div>
              </div>
            </div> -->
            <!-- <span [ngClass]="stepTwoDone? 'solid-line': 'vertical-line3'"></span> -->
          </div>
        </div>
        <div class="col-12">
          <div class="row no-gutters" id="track3" [ngClass]="stepThreeSelected? 'add-top': ''">
            <div class="col-lg-12">
              <div class="row no-gutters">
                <div class="col-lg-1 col-xs-12" id="circle">
                  <button id="btn3-desc" [ngClass]="[stepThreeSelected ? 'btn3-selected' : 'btn-unselected',
                  underLineStep3? 'btn-unselected' : 'btn1' ] " aria-label="step3" [disabled]="disableStep">
                    <p *ngIf="stepThreeIcon" id="btn-no">3</p>
                  </button>
                </div>
                <div class="col-lg-11 col-xs-12" id="text">
                  <p [ngClass]="[stepThreeSelected ? 'static-text3-selected' : 'static-text',
                  underLineStep3? 'ul-3': '']" id="static-text-desc">
                    {{cfetLabels.cfet_customer_eligibility.utf_activation}}</p>
                </div>
              </div>
            </div>
            <!-- <div id="show-sub-details" class="col-lg-12 col-8">
              <div class="row no-gutters">
                <div class="col-lg-12 col-6 role-mobile-max">
                  <div class="row no-gutters sub-detail1">
                    <div class="col-xs-12 col-lg-1">
                      <p id="sub-detail-btn" class="sub-bt"
                        [ngClass]="(progressTrackerStatus == 'createPwd' || progressTrackerStatus == 'confirmOtppage')? 'sub-bt-disc': 'sub-bt'">
                      </p>
                    </div>
                    <div class="col-xs-12 col-lg-10 sub-detail-heading"
                      [ngClass]="(progressTrackerStatus == 'createPwd') ? 'ff-b' : 'ff-nb'">
                      {{cfetLabels.cfet_customer_eligibility.utf_create_pwd}}</div>
                  </div>
                </div>
                <span [ngClass]="(progressTrackerStatus == 'confirmOtppage')? 'solid-line sl2': 'vertical-line2'"
                  class="solid-line2"></span>
                <div class="col-lg-12 col-6 role-mobile-max">
                  <div class="row no-gutters last-block sub-detail2">
                    <div class="col-xs-12 col-lg-1">
                      <p id="sub-detail-btn" class="sub-bt last-btn"
                        [ngClass]="(progressTrackerStatus == 'confirmOtppage')? 'sub-bt-disc': 'sub-bt'"></p>
                    </div>
                    <div class="col-xs-12 col-lg-10 sub-detail-heading last-block"
                      [ngClass]="(progressTrackerStatus == 'confirmOtppage') ? 'ff-b' : 'ff-nb'">
                      {{cfetLabels.cfet_customer_eligibility.utf_confirm_userid}}</div>
                  </div>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>